import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import * as moment from 'moment';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-ia-user-access',
  templateUrl: './ia-user-access.component.html',
  styleUrls: ['./ia-user-access.component.scss']
})
export class IaUserAccessComponent implements OnInit {

  IAMarksForm: FormGroup;
  SuperExamForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  StudentTable: [];
  colrChang = false;
  CountTable: [];
  StuArray: FormArray;
  HeadArray: FormArray;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  SaveBtn = false;
  UpdateBtn = false;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  assignTableData: any[];
  headTableData: any[];
  Student: any;
  errMsg: any;
  currentDate: Date;
  // jsonData: any;
  examList
  filteredListExam
  subjectList = []
  filteredsubjectList
  isBranch = false;
  Iamarks = 0
  BranchList
  filteredListBranch
  emid
  subcode
  savedpayload: any;
  SubMarkList: any;
  HeadList: any;
  filteredListHead: any;
  headcode: any;
  IaAtdCreate = true;
  IaAtdUpdate = true;
  userPermission: any;
  UserCollege
  utp: string;
  saveDisable: boolean;
  updateDisable: boolean;
  IamarksCounts
  IsFile = false;
  passMarks: any;
  maxMarks: any;
  status: any;
  finalPayload: any[] = [];
  finalPayloadUpdate: any[] = [];
  errMsgInvalid: boolean = false;
  head: any;
  sub: any;
  message: any;
  closeMessage: any;
  IATable: boolean = false
  userList: any[] = []
  filteredUserList: any[] = [];
  selectedSupervisors: any[] = [];
  subName: any;
  subId: any;
  IaId: any;
  supervisorsList: any;
  selectedSupervisor: any;
  selectedSupervisorIndex: number | null = null;
  headTable: boolean = false;
  tableShow: boolean;

  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService, public datepipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Student IA Iamarks' && element.PCreate == false) {
          this.IaAtdCreate = false;
        }
        if (element.PageName == 'Student IA Iamarks' && element.PUpdate == false) {
          this.IaAtdUpdate = false;
        }

      });
    }
    this.IsFile = false
    this.saveDisable = false
    this.updateDisable = false
    this.SaveBtn = false;
    this.UpdateBtn = false;
    this.Table = false
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    this.Iamarks = 0
    let id = ''
    this.submitButton = true;
    this.editButton = false;
    this.IAMarksForm = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
      EmId: new FormControl(''),
      SubCode: new FormControl(''),
      EsId: new FormControl(''),
      Branch: new FormControl(''),
      EsParentId: new FormControl(''),
      StuArray: new FormArray([]),
      HeadArray: new FormArray([]),
    });
    this.fetchSession(id);
    this.getClg();
    this.currentDate = new Date();
  }

  getStuArrayControls() {
    return (this.IAMarksForm.get('StuArray') as FormArray).controls;
  }



  fetchSession(id) {
    this.spinner.show();
    const payload = {};
    this.filteredListCourse = [];
    this.filteredCollegeList = [];
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }

  getCourse(data) {
    this.closeMessage = '';
    this.message = ''
    this.finalPayload = []
    let payload2 = this.IAMarksForm.value
    this.Table = false
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.isBranch = false;
    this.Table = false;
    this.IAMarksForm.controls['course'].setValue('');
    this.IAMarksForm.controls['EmId'].setValue('');
    this.IAMarksForm.controls['EsParentId'].setValue('');
    this.IAMarksForm.controls['EsId'].setValue('');
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.examList = []
    this.CourseList = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = payload2.college;
    payload['SessionId'] = payload2.SessionId;

    // getSessionColgCo
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getClg() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.Table = false;
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.subcode = '';
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
    })
  }







  redirect(to): void {
    this.router.navigate([to]);
  }

  errorcheckR(i) {
    return i.controls['Iamarks'].touched && i.controls['Iamarks'].errors?.pattern
  }

  LessThan(i) {
    return i.controls['Iamarks'].touched && i.controls['Iamarks'].errors?.max
  }





  getExamList(e) {

    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.closeMessage = ''
    this.message = ''
    this.finalPayload = []
    this.Table = false;
    this.spinner.show();
    this.filteredsubjectList = [];
    this.examList = []
    this.isBranch = false;
    const payload = {};
    payload['EmCoCode'] = e;
    this.filteredsubjectList = [];
    this.examList = []
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {

        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }



  getSubject(e) {
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.closeMessage = '';
    this.message = ''
    this.isBranch = false;
    this.spinner.show();
    this.Table = false;
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.IAMarksForm.controls['EsId'].setValue('');
    this.subjectList = []
    this.emid = e.EmId;
    if (e.EmStreams == "Y") {
      this.spinner.hide();
      this.isBranch = true;
      this.fetchBranch(e.EmId);
      // this.emid = e.EmId;
    } else {
      this.isBranch = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {

        this.spinner.hide();
        res.data.children.forEach(element => {
          if (element.EsType == 'S') {
            this.subjectList.push(element)

          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();

        });
      });
    }

  }


  fetchBranch(id) {
    const payload = {};
    this.filteredsubjectList = [];
    this.subjectList = [];
    this.HeadList = [];
    this.IAMarksForm.controls['EsId'].setValue('');
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }


  getStr(e) {
    this.closeMessage = ''
    this.message = ''
    this.finalPayload = []
    this.spinner.show();
    this.Table = false;
    this.filteredsubjectList = [];
    this.subjectList = []
    this.HeadList = [];
    let payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = this.IAMarksForm.value.Branch;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {

        res.data.children.forEach(element => {
          if (element.EsType == 'S') {
            this.subjectList.push(element)
          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();
        });
      }
      else {
        this.subjectList = [];
        this.filteredsubjectList = [];

      }

    }, (ERROR: HttpErrorResponse) => {
      this.subjectList = [];
      this.filteredsubjectList = [];
    });
  }

  subjectClick(data) {
    this.tableShow = true;
    this.sub = data.EsCode
    this.subName = data.EsName
    this.clear();

    this.closeMessage = ''
    this.message = ''
    this.spinner.show();
    this.HeadList = [];
    this.filteredListHead = [];
    this.Table = false;
    this.subcode = data.EsCode;
    this.subId = data.EsId
    this.finalPayload = []
    this.selectedSupervisors = [];
    const payload = {};
    payload['EsId'] = data.EsId;
    // Force UI refresh
    this.cdr.detectChanges();
    const creds = this.IAMarksForm.get('HeadArray') as FormArray;
    creds.clear();
    this.umsService.getStuIASub(payload).subscribe(res => {

      this.spinner.hide();
      if (res.status) {
        this.tableShow = true;
        this.HeadList = res.data;
        this.passMarks = this.HeadList[0].EsPassMarks
        this.maxMarks = this.HeadList[0].EsMaxMarks
        this.head = this.HeadList[0].EsCode
        this.filteredListHead = this.HeadList.slice();




        this.userClick()
        // this.ShowTable()
        this.getIaMarksHead()

      }
      else {
        this.HeadList = [];
        this.IAMarksForm.controls['EsId'].setValue('');
        this.tableShow = false;
      }

    }, (ERROR: HttpErrorResponse) => {
      this.HeadList = [];
      this.IAMarksForm.controls['EsId'].setValue('');

      this.spinner.hide();
      
      let data = {}
      data['message'] = 'No Data Found For This Filter'
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    })
  }

  getIaMarksHead() {
    this.spinner.show();
    this.submitpayload = this.IAMarksForm.value;
    let payload = {
      SnNo: this.submitpayload['SessionId'],
      CgCode: this.submitpayload['college'],
      CoCode: this.submitpayload['course'],
      EmId: this.submitpayload['EmId'],
      EsIdIASub: this.subId
    };

    this.umsService.getIaMarksHeadData(payload).subscribe(
      (res) => {
        this.spinner.hide();

        // Clear the FormArray before adding new controls
        const creds = this.IAMarksForm.get('HeadArray') as FormArray;
        creds.clear();  // Clear the FormArray

        if (res.status) {
          this.headTableData = res.data; // Populating the headTableData from the API response
          this.Table = true;
          this.SaveBtn = false;
          this.UpdateBtn = true;

          // Populate FormArray using headTableData
          this.headTableData.forEach((element, i) => {
            const selectedUser = this.userList.find(user => user.LoginId === element['LoginId']);

            const creds = this.IAMarksForm.get('HeadArray') as FormArray;
            creds.push(
              this.fb.group({
                SrNo: new FormControl(i + 1),  // Serial number based on loop index
                Name: new FormControl(element['LoginName'] || ''),  // Using LoginName for Name field (prefill)
                CgCode: new FormControl(element['CgCode']),
                CoCode: new FormControl(element['CoCode']),
                EhDefName: new FormControl(element['EhDefName']),
                EmId: new FormControl(element['EmId']),
                EsIdIASub: new FormControl(element['EsIdIASub']),
                EsIdSubHead: new FormControl(element['EsIdSubHead']),
                LoginId: new FormControl(element['LoginId']),
                SnNo: new FormControl(element['SnNo']),
                UserId: new FormControl(element['User Id']),
                LoginName: new FormControl(selectedUser ? selectedUser.LoginFullName : '')
              })
            );
          });


        } else {
          // Force UI refresh
          this.Table = true;
          this.SaveBtn = true;
          this.UpdateBtn = false;

          // Manually create headTableData based on HeadList
          this.headTableData = this.HeadList.map((element, i) => {
            return {
              EsName: element['EsName'],
              EsId: element['EsId'],
              LoginId: element['LoginId'] || '',  // Assuming an empty string if LoginId is missing
              // Add other fields as needed, for example:
              // Additional fields from HeadList can go here if necessary.
            };
          });

          // Populate FormArray using the newly created headTableData
          this.headTableData.forEach((element, i) => {
            const creds = this.IAMarksForm.get('HeadArray') as FormArray;
            creds.push(
              this.fb.group({
                SrNo: new FormControl(i + 1),
                EhDefName: new FormControl(element['EsName']),
                EsId: new FormControl(element['EsId']),
                LoginId: new FormControl(element['LoginId']),
              })
            );
          });

        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.collegeList = [];
        console.error('Error fetching IA Marks:', ERROR);
      }
    );
  }


  async Save() {
    try {
      await this.saveIaMarksThreshold();
      this.showSuccessMessage("Submitted Successfully");
    } catch (error) {
      this.showErrorMessage(this.errMsg || "An error occurred");
    }

  }

  showSuccessMessage(message: string) {
    let data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-check'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      this.userClick();
    });
  }

  showErrorMessage(message: string) {
    let data = {
      message: message,
      title: 'Alert',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      this.userClick();
    });
  }


  async saveIaMarksThreshold() {
    return new Promise<void>((resolve, reject) => {
      this.spinner.show();
      let iserror = false;
      this.submitpayload = this.IAMarksForm.value;
      this.finalPayload = [];
      this.selectedSupervisors.forEach((element) => {
        let payload = {
          SnNo: this.submitpayload['SessionId'],
          CgCode: this.submitpayload['college'],
          CoCode: this.submitpayload['course'],
          EmId: this.submitpayload['EmId'],
          IASub: this.sub,
          IASubHead: element ? element.HeadCode : '',  // Fill with HeadCode from the element
          EsIdIASub: this.subId,
          EsIdSubHead: element ? element.HeadId : '',  // Fill with HeadId from the element
          UserId: element.supervisorId,  // Fill with supervisorId from the element
        };

        // Do whatever is needed with the payload, for example:

        this.finalPayload.push(payload);
        // You can also push it to an array if you need to accumulate multiple payloads
        // this.payloadArray.push(payload);
      });

      // Push the payload to finalPayload array
      this.umsService.saveStuIaMarksThreshold(this.finalPayload).subscribe(
        (res) => {
          this.spinner.hide();
          if (res.status) {
            resolve(); // Resolve promise on success
            this.headTableData = []
            this.selectedSupervisors = []
            this.getIaMarksHead()
          } else {
            this.errMsg = res.message || "Error occurred while saving threshold";
            reject(this.errMsg); // Reject promise if there's an error
          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message;
          reject(this.errMsg); // Reject promise if an error occurs
        }
      );
    });
  }


  async update() {
    if (this.IAMarksForm.invalid) {
      this.IAMarksForm.get('SessionId').markAsTouched();
      this.StuArray = this.IAMarksForm.get('StuArray') as FormArray;
      this.IAMarksForm.get('EmId').markAsTouched();
      this.IAMarksForm.get('EsParentId').markAsTouched();
      this.IAMarksForm.get('EsId').markAsTouched();

      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Iamarks').markAsTouched();
        })
      }
    }
    else {
      try {
        await this.updateIaMarksThreshold();
        this.showSuccessMessage("Updated Successfully");
      } catch (error) {
        this.showErrorMessage(this.errMsg || "An error occurred");
      }
    }
  }

  async updateIaMarksThreshold() {
    // updateStdAtd
    return new Promise<void>((resolve, reject) => {
      this.spinner.show();
      let iserror = false;
      this.submitpayload = this.IAMarksForm.value;
      this.finalPayload = [];


      this.selectedSupervisors.forEach((element) => {
        let payload = {
          IAMarksId: element.IAMarksId,
          SnNo: this.submitpayload['SessionId'],
          CgCode: this.submitpayload['college'],
          CoCode: this.submitpayload['course'],
          EmId: this.submitpayload['EmId'],
          IASub: this.sub,
          IASubHead: element ? element.HeadCode : '',  // Fill with HeadCode from the element
          EsIdIASub: this.subId,
          EsIdSubHead: element ? element.HeadId : '',  // Fill with HeadId from the element
          UserId: element.supervisorId,  // Fill with supervisorId from the element
        };
        this.finalPayload.push(payload);
      });
      this.umsService.updateStuIaMarksThreshold(this.finalPayload).subscribe(
        (res) => {
          this.spinner.hide();
          if (res.status) {
            resolve(); // Resolve promise on success
            this.getIaMarksHead()
          } else {
            this.errMsg = res.message || "Error occurred while saving threshold";
            reject(this.errMsg); // Reject promise if there's an error
          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message;
          reject(this.errMsg); // Reject promise if an error occurs
        }
      );
    });
  }





  File(event: any) {

    const data = {};
    data['message'] = 'Do You Want To Upload This File ?';
    data['title'] = 'Information';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.dialogRef.close();
        const files: FileList = event.target.files;
        const allowedExtensions = ['csv'];

        if (files && files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            const file: File = files[i];
            const extension = file.name.split('.').pop().toLowerCase();

            if (allowedExtensions.includes(extension)) {
              // Process the selected file here (e.g., read its content or upload it)
              // let data = {};
              // data['message'] = 'File Uploaded Successfully';
              // data['title'] = 'Information';
              // data['icon'] = 'fas fa-check';
              // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
              //   AlertBoxComponent,
              //   data
              // );
              // this.SearchEditMarks();
              // this.ControlLock2(parseInt(this.LoginId));
              this.getTextFromFile(file);

            } else {
            }
          }
        }
      }
      else {
        this.dialogRef.close();
      }
    });




  }
  importDataFromCSV(csvText: string): Array<any> {
    const propertyNames = csvText.slice(0, csvText.indexOf('\n')).split(',');
    const dataRows = csvText.slice(csvText.indexOf('\n') + 1).split('\n');
    let dataArray: any[] = [];
    dataRows.forEach((row) => {
      let values = row.split(',');
      let obj: any = new Object();
      for (let index = 0; index < propertyNames.length; index++) {
        const propertyName: string = propertyNames[index];
        let val: any = values[index];
        if (val === '') {
          val = parseInt;
        }
        obj[propertyName] = val;
      }
      dataArray.push(obj);
    });
    return dataArray;
  }
  async getTextFromFile(file) {
    // const file: File = event.target.files[0];
    let fileContent = await file.text();
    const importedData = this.importDataFromCSV(fileContent);
    this.processCsvContents(importedData.slice(0, importedData.length - 1));
  }
  ///
  processCsvContents(dataArray): void {

    let MarksCounttt = this.Iamarks;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      dataArray.forEach((element, index, array) => {
        const userId: string | null = sessionStorage.getItem('userId');
        const entryDateTime: Date = this.currentDate;
        element.UserID = userId;
        element.EntryDateTime = entryDateTime;
        element.SessionID = this.IAMarksForm.value.SessionId;
        element.EmId = this.IAMarksForm.value.EmId;
        element.EsId = this.IAMarksForm.value.EsId;
        element.EsParentId = this.IAMarksForm.value.EsParentId;
        element.HeadCode = this.headcode;
        element.CoCode = this.IAMarksForm.value.course;
        element.CgCode = this.IAMarksForm.value.college
        element.SubCode = this.subcode;
        element.Branch = this.IAMarksForm.value.Branch;
        if (MarksCounttt == parseInt(element['Iamarks']) || parseInt(element['Iamarks']) > MarksCounttt) {
          element['IAMarksStatus'] = 'P'
        }
        else {
          element['IAMarksStatus'] = 'F'
        }
        this.IamarksCounts = this.assignTableData[0]['Iamarks'];
        this.assignTableData[0]['Iamarks']
        element['Iamarks'] = parseInt(element['Iamarks']);
        element['ScrutinyID'] = 0;
        // return
        if (this.IamarksCounts == '' || this.assignTableData[0]['Iamarks'] == null) {
          this.umsService.saveStuIAAtd(element).subscribe((res) => {
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false
              this.errMsg = res.message

            }
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();

          });
        } else {
          this.umsService.updateStuIAAtd(element).subscribe((res) => {
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false
              this.errMsg = res.message
              this.ngOnInit()
            }
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();

          });
        }

      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Uploaded Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ShowTable()
        });

      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ShowTable()
        });
      }
    });
  }

  dowload() {
    const link = document.createElement("a");
    link.href = '../../assets/excel/IA Iamarks 2.csv';
    link.download = 'Download';
    link.click()
  }


  download2(event: Event) {
    event.preventDefault();

    const extractedData = this.assignTableData.map(element => ({
      // StuID: element.StuId,
      // Name: element.StuFirstNameEng + " " + element.StuMidNameEng + " " + element.StuLastNameEng,
      subCode: this.sub,
      HeadCode: this.head,
      section: 0,
      regno: element.StuRgNo,
      marks: element.IAMarks,
      // IAMarksStatus: element.IAMarksStatus,

      ScrutinyID: 0,
    }));

    // Convert array data to CSV format
    const csvContent = this.convertArrayToCSV(extractedData);
    // Create a Blob
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a download link
    const link = document.createElement('a');
    link.href = url;
    link.download = 'data.csv'; // You can change the file name if needed
    document.body.appendChild(link);

    // Trigger the download
    link.click();
  }

  convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');
    const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
    return [header, ...rows].join('\n');
  }


  clear() {
    this.SuperExamForm = this.fb.group({
      exam: new FormControl(''),
      user: new FormControl(''),
      UserArr: this.fb.array([]),
      ExamArr: this.fb.array([]),
    });
  }

  userClick() {
    this.clear();
    this.spinner.show();
    let payload = {}
    this.umsService.getUserList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.userList = res.data;

        this.filteredUserList = this.userList.slice();
        // Force a UI refresh after setting new data
        this.cdr.detectChanges();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
    // bar.then(() => {
    //   this.addclgexam();
    // });
  }

  onSupervisorChange(event: any, index: number, markData: any) {
    // Handle the logic when a supervisor is selected from the dropdown
    const data = this.userList.filter(user => user.LoginId === event.value);

    // If data is not empty, you can map through filteredListHead and assign supervisorId
    if (data.length > 0) {
      // Create the updated supervisor object for the specific row (index)
      const updatedSupervisor = {
        HeadId: this.filteredListHead[index].EsId, // Use the index to get the correct head
        HeadCode: this.filteredListHead[index].EsCode,
        supervisorId: data[0].LoginId,  // Update with the selected supervisor's LoginId
        IAMarksId: markData.IAMarksId
      };

      // Check if the supervisor already exists in selectedSupervisors
      const existingSupervisorIndex = this.selectedSupervisors.findIndex(
        supervisor => supervisor.HeadId === updatedSupervisor.HeadId
      );

      if (existingSupervisorIndex !== -1) {
        // If the supervisor already exists, update it
        this.selectedSupervisors[existingSupervisorIndex] = updatedSupervisor;
      } else {
        // If the supervisor doesn't exist, push the new supervisor
        this.selectedSupervisors.push(updatedSupervisor);
      }
      
    } 
    // Example: You can update the selected supervisor in the markData object if needed
    markData.LoginId = event.value;
  }


}
